<cc-container [fullWidth]="true">
  <div class="light-border">
    <form
      ccTableHeader
      [formGroup]="searchForm"
      (ngSubmit)="dataSource.search(searchForm.getRawValue())">
      <input
        type="text"
        ccInput
        placeholder="{{'SEARCH' | translate}}"
        formControlName="msisdnLike">
      <mat-checkbox (change)="filterByDate($event)"><span translate>BLACKLIST.FILTER</span>
      </mat-checkbox>
      <div>
        <cc-date-range-picker
          *ngIf="showDateRangePicker"
          (selected)="dataSource.search($event)"></cc-date-range-picker>
      </div>
      <button
        mat-raised-button
        type="button"
        (click)="addToBlacklist()"
        [disabled]="!dataSource.selection.hasValue()"
        color="primary">
        <span translate>BLACKLIST.ADD</span>
      </button>
      <button
        mat-raised-button
        type="button"
        (click)="removeToBlacklist()"
        [disabled]="!dataSource.selection.hasValue()"
        color="primary">
        <span translate>BLACKLIST.REMOVE</span>
      </button>
    </form>
    <mat-table
      #table
      matSort
      (matSortChange)="dataSource.sort($event)"
      [dataSource]="dataSource">

      <ng-container matColumnDef="open-action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <cc-show-row
            [expanded]="element.expanded"
            *ngIf="element.sameMsisdnEventsCount > 1"
            (changed)="onChanged($event, element)"></cc-show-row>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="number">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="msisdn">
          <span translate>BLACKLIST.MSISDN</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <cc-mobile-header translate>BLACKLIST.MSISDN</cc-mobile-header>
          <span>{{element.msisdn}}</span>
          <mat-icon
            class="blocked"
            *ngIf="element.status === 'BLOCKED'">remove_circle_outline
          </mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="user">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="username">
          <span translate>BLACKLIST.USER</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="expand">
          <cc-mobile-header translate>BLACKLIST.USER</cc-mobile-header>
          <cc-cell-container>
            <span *ngIf="!element.additional">{{element.username}}</span>
            <span *ngFor="let additional of element.additional">
        <span>{{additional.username}}</span><br>
      </span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="eventDate">
          <span translate>BLACKLIST.DATE</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="expand">
          <cc-mobile-header translate>BLACKLIST.DATE</cc-mobile-header>
          <cc-cell-container>
            <span *ngIf="!element.additional">{{element.eventDate | ccDate}}</span>
            <span *ngFor="let additional of element.additional">
        <span>{{additional.eventDate | ccDate}}</span><br>
      </span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header="status">
          <span translate>BLACKLIST.STATUS.LABEL</span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="expand">
          <cc-mobile-header translate>BLACKLIST.STATUS.LABEL</cc-mobile-header>
          <cc-cell-container>
         <span
           *ngIf="!element.additional"
           translate>{{'BLACKLIST.STATUS.' + element.status}}</span>
            <span *ngFor="let additional of element.additional">
        <span translate>{{'BLACKLIST.STATUS.' + additional.status}}</span>
      </span>
          </cc-cell-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? dataSource.masterToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"></mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(row) : null"
            [checked]="dataSource.selection.isSelected(row)"></mat-checkbox>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <mat-paginator
      *ngIf="dataSource.empty"
      [length]="dataSource.total"
      (page)="dataSource.page($event)"
      [pageIndex]="dataSource.pageIndex"
      [pageSize]="dataSource.params.limit"
      [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    <cc-empty-table-message [hidden]="dataSource.empty">
      <span translate>NO_DATA</span>
    </cc-empty-table-message>
  </div>
</cc-container>
